import axios from '@/api/$axios'
export default {
  check () {
    return axios.get(`/credits`)
  },
  update () {
    return axios.post(`/credits`)
  }
}
